const keyMirror = require('keymirror');

module.exports = keyMirror({
    CALL_API: null,
    CALL_API_MULTIPART: null,

    API_REQUEST: null,
    REQUEST_SUCCESS: null,
    REQUEST_FAILURE: null,

    SWITCH_ACCOUNT_REQUEST: null,
    SWITCH_ACCOUNT_SUCCESS: null,
    SWITCH_ACCOUNT_FAILURE: null,

    SET_FCM_TOKEN_REQUEST: null,
    SET_FCM_TOKEN_SUCCESS: null,
    SET_FCM_TOKEN_FAILURE: null,

    CLEAR_FCM_TOKEN_REQUEST: null,
    CLEAR_FCM_TOKEN_SUCCESS: null,
    CLEAR_FCM_TOKEN_FAILURE: null,

    CREATE_JOB_REQUEST: null,
    CREATE_JOB_SUCCESS: null,
    CREATE_JOB_FAILURE: null,
    DELETE_JOB_REQUEST: null,
    DELETE_JOB_SUCCESS: null,
    DELETE_JOB_FAILURE: null,
    COMPLETE_JOB_REQUEST: null,
    COMPLETE_JOB_SUCCESS: null,
    COMPLETE_JOB_FAILURE: null,
    UNCOMPLETE_JOB_REQUEST: null,
    UNCOMPLETE_JOB_SUCCESS: null,
    UNCOMPLETE_JOB_FAILURE: null,
    GET_JOB_REQUEST: null,
    GET_JOB_SUCCESS: null,
    GET_JOB_FAILURE: null,
    GET_JOBS_REQUEST: null,
    GET_JOBS_SUCCESS: null,
    GET_JOBS_FAILURE: null,
    UPDATE_JOB_REQUEST: null,
    UPDATE_JOB_SUCCESS: null,
    UPDATE_JOB_FAILURE: null,
    GET_JOBBERS_REQUEST: null,
    GET_JOBBERS_SUCCESS: null,
    GET_JOBBERS_FAILURE: null,

    CREATE_CHAT_REQUEST: null,
    CREATE_CHAT_SUCCESS: null,
    CREATE_CHAT_FAILURE: null,
    UPDATE_CHAT_REQUEST: null,
    UPDATE_CHAT_SUCCESS: null,
    UPDATE_CHAT_FAILURE: null,
    GET_ROOM_BY_ID_REQUEST: null,
    GET_ROOM_BY_ID_SUCCESS: null,
    GET_ROOM_BY_ID_FAILURE: null,
    GET_CHAT_ROOMS_REQUEST: null,
    GET_CHAT_ROOMS_SUCCESS: null,
    GET_CHAT_ROOMS_FAILURE: null,
    GET_CHAT_ROOMS_BY_JOBID_REQUEST: null,
    GET_CHAT_ROOMSBY_JOBID__SUCCESS: null,
    GET_CHAT_ROOMSBY_JOBID__FAILURE: null,
    GET_ARCIVED_CHAT_ROOMS_REQUEST: null,
    GET_ARCIVED_CHAT_ROOMS_SUCCESS: null,
    GET_ARCIVED_CHAT_ROOMS_FAILURE: null,
    GET_IS_ARCHIVED_ROOM_REQUEST: null,
    GET_IS_ARCHIVED_ROOM_SUCCESS: null,
    GET_IS_ARCHIVED_ROOM_FAILURE: null,
    GET_MESSAGES_HISTORY_REQUEST: null,
    GET_MESSAGES_HISTORY_SUCCESS: null,
    GET_MESSAGES_HISTORY_FAILURE: null,
    SEND_MESSAGE_REQUEST: null,
    SEND_MESSAGE_SUCCESS: null,
    SEND_MESSAGE_FAILURE: null,
    ARCHIVE_ROOM_REQUEST: null,
    ARCHIVE_ROOM_SUCCESS: null,
    ARCHIVE_ROOM_FAILURE: null,
    LEAVE_ROOM_REQUEST: null,
    LEAVE_ROOM_SUCCESS: null,
    LEAVE_ROOM_FAILURE: null,
    DELETE_USER_ROOM_REQUEST: null,
    DELETE_USER_ROOM_SUCCESS: null,
    DELETE_USER_ROOM_FAILURE: null,
    SEND_MEDIA_REQUEST: null,
    SEND_MEDIA_SUCCESS: null,
    SEND_MEDIA_FAILURE: null,
    DELETE_CHAT_ROOM_REQUEST: null,
    DELETE_CHAT_ROOM_SUCCESS: null,
    DELETE_CHAT_ROOM_FAILURE: null,
    GET_CHAT_ROOM_BY_JOBBER_REQUEST: null,
    GET_CHAT_ROOM_BY_JOBBER_SUCCESS: null,
    GET_CHAT_ROOM_BY_JOBBER_FAILURE: null,

    CREATE_OFFER_REQUEST: null,
    CREATE_OFFER_SUCCESS: null,
    CREATE_OFFER_FAILURE: null,
    GET_OFFERS_REQUEST: null,
    GET_OFFERS_SUCCESS: null,
    GET_OFFERS_FAILURE: null,
    GET_ARCHIVED_OFFERS_REQUEST: null,
    GET_ARCHIVED_OFFERS_SUCCESS: null,
    GET_ARCHIVED_OFFERS_FAILURE: null,
    GET_OFFER_REQUEST: null,
    GET_OFFER_SUCCESS: null,
    GET_OFFER_FAILURE: null,
    UPDATE_OFFER_REQUEST: null,
    UPDATE_OFFER_SUCCESS: null,
    UPDATE_OFFER_FAILURE: null,
    DELETE_OFFER_REQUEST: null,
    DELETE_OFFER_SUCCESS: null,
    DELETE_OFFER_FAILURE: null,
    DECLINE_OFFER_REQUEST: null,
    DECLINE_OFFER_SUCCESS: null,
    DECLINE_OFFER_FAILURE: null,

    CREATE_CONTRACT_REQUEST: null,
    CREATE_CONTRACT_SUCCESS: null,
    CREATE_CONTRACT_FAILURE: null,
    GET_CONTRACTS_REQUEST: null,
    GET_CONTRACTS_SUCCESS: null,
    GET_CONTRACTS_FAILURE: null,
    GET_CONTRACT_REQUEST: null,
    GET_CONTRACT_SUCCESS: null,
    GET_CONTRACT_FAILURE: null,
    GET_CONTRACT_BY_JOBBER_REQUEST: null,
    GET_CONTRACT_BY_JOBBER_SUCCESS: null,
    GET_CONTRACT_BY_JOBBER_FAILURE: null,
    CLOSE_CONTRACT_RQEUEST: null,
    CLOSE_CONTRACT_SUCCESS: null,
    CLOSE_CONTRACT_FAILURE: null,
    CLOSE_ALL_CONTRACTS_REQUEST: null,
    CLOSE_ALL_CONTRACTS_SUCCESS: null,
    CLOSE_ALL_CONTRACTS_FAILURE: null,
    ARCHIEVE_ALL_CONTRACTS_REQUEST: null,
    ARCHIEVE_ALL_CONTRACTS_SUCCESS: null,
    ARCHIEVE_ALL_CONTRACTS_FAILURE: null,
    ARCHIEVE_CONTRACT_REQUEST: null,
    ARCHIEVE_CONTRACT_SUCCESS: null,
    ARCHIEVE_CONTRACT_FAILURE: null,
    ASSIGN_SCHEDULE_REQUEST: null,
    ASSIGN_SCHEDULE_SUCCESS: null,
    ASSIGN_SCHEDULE_FAILURE: null,
    UNASSIGN_SCHEDULE_REQUEST: null,
    UNASSIGN_SCHEDULE_SUCCESS: null,
    UNASSIGN_SCHEDULE_FAILURE: null,
    GET_ARCHIEVE_CONTRACT_REQUEST: null,
    GET_ARCHIEVE_CONTRACT_SUCCESS: null,
    GET_ARCHIEVE_CONTRACT_FAILURE: null,
    FIND_CONTRACT_JOBBERS_REQUEST: null,
    FIND_CONTRACT_JOBBERS_SUCCESS: null,
    FIND_CONTRACT_JOBBERS_FAILURE: null,

    GET_INVITES_REQUEST: null,
    GET_INVITES_SUCCESS: null,
    GET_INVITES_FAILURE: null,
    GET_INVITE_REQUEST: null,
    GET_INVITE_SUCCESS: null,
    GET_INVITE_FAILURE: null,
    DECLINE_INVITE_REQUEST: null,
    DECLINE_INVITE_SUCCESS: null,
    DECLINE_INVITE_FAILURE: null,
    CREATE_INVITE_RQEUEST: null,
    CREATE_INVITE_SUCCESS: null,
    CREATE_INVITE_FAILURE: null,

    CREATE_INVOICE_REQUEST: null,
    CREATE_INVOICE_SUCCESS: null,
    CREATE_INVOICE_FAILURE: null,
    GET_INVOICES_REQUEST: null,
    GET_INVOICES_SUCCESS: null,
    GET_INVOICES_FAILURE: null,
    GET_INVOICE_REQUEST: null,
    GET_INVOICE_SUCCESS: null,
    GET_INVOICE_FAILURE: null,
    GET_LAST_INVOICE_REQUEST: null,
    GET_LAST_INVOICE_SUCCESS: null,
    GET_LAST_INVOICE_FAILURE: null,

    GET_NOTIFICATIONS_REQUEST: null,
    GET_NOTIFICATIONS_SUCCESS: null,
    GET_NOTIFICATIONS_FAILURE: null,

    GET_BADGE_COUNT_REQUEST: null,
    GET_BADGE_COUNT_SUCCESS: null,
    GET_BADGE_COUNT_FAILURE: null,

    UPDATE_BADGE_COUNT: null,

    GET_SCHEDULES_REQUEST: null,
    GET_SCHEDULES_SUCCESS: null,
    GET_SCHEDULES_FAILURE: null,
    UPDATE_SCHEDULES_REQUEST: null,
    UPDATE_SCHEDULES_SUCCESS: null,
    UPDATE_SCHEDULES_FAILURE: null,

    UPDATE_HEADER_PARAMS: null,
    UPDATE_SCHEDULE: null,
    REMOVE_JOB: null,
    //admin actions
    ADMIN_LOGIN_REQUEST: null,
    ADMIN_LOGIN_SUCCESS: null,
    ADMIN_LOGIN_FAILURE: null,

    ADMIN_LOGOUT_REQUEST: null,
    ADMIN_LOGOUT_SUCCESS: null,
    ADMIN_LOGOUT_FAILURE: null,

    //admin category actions
    ADMIN_CREATE_CATEGORY_REQUEST: null,
    ADMIN_CREATE_CATEGORY_SUCCESS: null,
    ADMIN_CREATE_CATEGORY_FAILURE: null,

    ADMIN_UPDATE_CATEGORY_REQUEST: null,
    ADMIN_UPDATE_CATEGORY_SUCCESS: null,
    ADMIN_UPDATE_CATEGORY_FAILURE: null,

    ADMIN_GET_CATEGORIES_REQUEST: null,
    ADMIN_GET_CATEGORIES_SUCCESS: null,
    ADMIN_GET_CATEGORIES_FAILURE: null,

    ADMIN_GET_CATEGORY_REQUEST: null,
    ADMIN_GET_CATEGORY_SUCCESS: null,
    ADMIN_GET_CATEGORY_FAILURE: null,

    ADMIN_DELETE_CATEGORY_REQUEST: null,
    ADMIN_DELETE_CATEGORY_SUCCESS: null,
    ADMIN_DELETE_CATEGORY_FAILURE: null,

    //admin get jobber type
    GET_JOBBER_TYPE_REQUEST: null,
    GET_JOBBER_TYPE_SUCCESS: null,
    GET_JOBBER_TYPE_FAILURE: null,

    //admin users actions
    USER_CREATE_REQUEST: null,
    USER_CREATE_SUCCESS: null,
    USER_CREATE_FAILURE: null,

    USERS_GET_REQUEST: null,
    USERS_GET_SUCCESS: null,
    USERS_GET_FAILURE: null,

    USER_DELETE_REQUEST: null,
    USER_DELETE_SUCCESS: null,
    USER_DELETE_FAILURE: null,

    SUB_USER_DELETE_REQUEST: null,
    SUB_USER_DELETE_SUCCESS: null,
    SUB_USER_DELETE_FAILURE: null,

    USER_GET_REQUEST: null,
    USER_GET_SUCCESS: null,
    USER_GET_FAILURE: null,

    SUB_USERS_GET_REQUEST: null,
    SUB_USERS_GET_SUCCESS: null,
    SUB_USERS_GET_FAILURE: null,

    SUB_USER_CREATE_REQUEST: null,
    SUB_USER_CREATE_SUCCESS: null,
    SUB_USER_CREATE_FAILURE: null,

    USER_UPDATE_REQUEST: null,
    USER_UPDATE_SUCCESS: null,
    USER_UPDATE_FAILURE: null,

    USER_PASSWORD_UPDATE_REQUEST: null,
    USER_PASSWORD_UPDATE_SUCCESS: null,
    USER_PASSWORD_UPDATE_FAILURE: null,

    ADMIN_DELETE_JOB_PIC_REQUEST: null,
    ADMIN_DELETE_JOB_PIC_SUCCESS: null,
    ADMIN_DELETE_JOB_PIC_FAILURE: null,

    ADMIN_JOB_PIC_UPDATE_REQUEST: null,
    ADMIN_JOB_PIC_UPDATE_SUCCESS: null,
    ADMIN_JOB_PIC_UPDATE_FAILURE: null,

    //admin payments
    ADMIN_GET_PAYMENTS_REQUEST: null,
    ADMIN_GET_PAYMENTS_SUCCESS: null,
    ADMIN_GET_PAYMENTS_FAILURE: null,

    ADMIN_GET_PAYMENTS_HISTORY_REQUEST: null,
    ADMIN_GET_PAYMENTS_HISTORY_SUCCESS: null,
    ADMIN_GET_PAYMENTS_HISTORY_FAILURE: null,

    ADMIN_GET_PAYMENT_REQUEST: null,
    ADMIN_GET_PAYMENT_SUCCESS: null,
    ADMIN_GET_SUBSCRITPION_FAILURE: null,

    ADMIN_REFUND_PAYMENT_REQUEST: null,
    ADMIN_REFUND_PAYMENT_SUCCESS: null,
    ADMIN_REFUND_PAYMENT_FAILURE: null,

    //admin dashboard
    ADMIN_GET_CARD_GRAPH_REQUEST: null,
    ADMIN_GET_CARD_GRAPH_SUCCESS: null,
    ADMIN_GET_CARD_GRAPH_FAILURE: null,

    ADMIN_GET_PAYMENT_GRAPH_REQUEST: null,
    ADMIN_GET_PAYMENT_GRAPH_SUCCESS: null,
    ADMIN_GET_PAYMENT_GRAPH_FAILURE: null,

    ADMIN_GET_TOP_RATED_USERS_REQUEST: null,
    ADMIN_GET_TOP_RATED_USERS_SUCCESS: null,
    ADMIN_GET_TOP_RATED_USERS_FAILURE: null,

    ADMIN_GET_CONTRACTS_GRAPH_REQUEST: null,
    ADMIN_GET_CONTRACTS_GRAPH_SUCCESS: null,
    ADMIN_GET_CONTRACTS_GRAPH_FAILURE: null,

    ADMIN_GET_USERS_INFO_REQUEST: null,
    ADMIN_GET_USERS_INFO_SUCCESS: null,
    ADMIN_GET_USERS_INFO_FAILURE: null,

    ADMIN_GET_JOBS_INFO_REQUEST: null,
    ADMIN_GET_JOBS_INFO_SUCCESS: null,
    ADMIN_GET_JOBS_INFO_FAILURE: null,

    CREATE_CATEGORY_REQUEST: null,
    CREATE_CATEGORY_SUCCESS: null,
    CREATE_CATEGORY_FAILURE: null,

    GET_CATEGORIES_REQUEST: null,
    GET_CATEGORIES_SUCCESS: null,
    GET_CATEGORIES_FAILURE: null,

    GET_CATEGORY_REQUEST: null,
    GET_CATEGORY_SUCCESS: null,
    GET_CATEGORY_FAILURE: null,

    UPDATE_CATEGORY_REQUEST: null,
    UPDATE_CATEGORY_SUCCESS: null,
    UPDATE_CATEGORY_FAILURE: null,

    DELETE_CATEGORY_REQUEST: null,
    DELETE_CATEGORY_SUCCESS: null,
    DELETE_CATEGORY_FAILURE: null,

    RESET_ADMIN_LOGIN_STATE: null,

    CREATE_GROUP_CHAT_REQUEST: null,
    CREATE_GROUP_CHAT_SUCCESS: null,
    CREATE_GROUP_CHAT_FAILURE: null,

    CREATE_DIRECT_CHAT_REQUEST: null,
    CREATE_DIRECT_CHAT_SUCCESS: null,
    CREATE_DIRECT_CHAT_FAILURE: null,

    CREATE_JOB_CHAT_REQUEST: null,
    CREATE_JOB_CHAT_SUCCESS: null,
    CREATE_JOB_CHAT_FAILURE: null,

    GET_GROUP_CHAT_HISTORY_REQUEST: null,
    GET_GROUP_CHAT_HISTORY_SUCCESS: null,
    GET_GROUP_CHAT_HISTORY_FAILURE: null,

    GET_DIRECT_CHAT_HISTORY_REQUEST: null,
    GET_DIRECT_CHAT_HISTORY_SUCCESS: null,
    GET_DIRECT_CHAT_HISTORY_FAILURE: null,

    GET_JOB_CHAT_HISTORY_REQUEST: null,
    GET_JOB_CHAT_HISTORY_SUCCESS: null,

    RECEIVE_MESSAGE: null,

    SEND_EMAIL_REQUEST: null,
    SEND_EMAIL_SUCCESS: null,
    SEND_EMAIL_FAILURE: null,

    SEND_NOTIFICATION_REQUEST: null,
    SEND_NOTIFICATION_SUCCESS: null,
    SEND_NOTIFICATION_FAILURE: null,

    CREATE_FEEDBACK_REQUEST: null,
    CREATE_FEEDBACK_SUCCESS: null,
    CREATE_FEEDBACK_FAILURE: null,

    GET_FEEDBACKS_REQUEST: null,
    GET_FEEDBACKS_SUCCESS: null,
    GET_FEEDBACKS_FAILURE: null,

    DELETE_FEEDBACK_REQUEST: null,
    DELETE_FEEDBACK_SUCCESS: null,
    DELETE_FEEDBACK_FAILURE: null,

    GET_FEEDBACK_BY_ID_REQUEST: null,
    GET_FEEDBACK_BY_ID_SUCCESS: null,
    GET_FEEDBACK_BY_ID_FAILURE: null,

    UPDATE_FEEDBACK_REQUEST: null,
    UPDATE_FEEDBACK_SUCCESS: null,
    UPDATE_FEEDBACK_FAILURE: null,

    GET_FAVORITE_JOBBERS_REQUEST: null,
    GET_FAVORITE_JOBBERS_SUCCESS: null,
    GET_FAVORITE_JOBBERS_FAILURE: null,

    UPDATE_FAVORITE_JOBBER_REQUEST: null,
    UPDATE_FAVORITE_JOBBER_SUCCESS: null,
    UPDATE_FAVORITE_JOBBER_FAILURE: null,

    GET_TERMS_REQUEST: null,
    GET_TERMS_SUCCESS: null,
    GET_TERMS_FAILURE: null,

    GET_FAQS_REQUEST: null,
    GET_FAQS_SUCCESS: null,
    GET_FAQS_FAILURE: null,

    GET_BANK_ACCOUNTS_REQUEST: null,
    GET_BANK_ACCOUNTS_SUCCESS: null,
    GET_BANK_ACCOUNTS_FAILURE: null,

    VERIFY_USER_ACCOUNT_REQUEST: null,
    VERIFY_USER_ACCOUNT_SUCCESS: null,
    VERIFY_USER_ACCOUNT_FAILURE: null,

    CHECK_ACCOUNT_VERIFIED_REQUEST: null,
    CHECK_ACCOUNT_VERIFIED_SUCCESS: null,
    CHECK_ACCOUNT_VERIFIED_FAILURE: null,

    GET_CARDS_REQUEST: null,
    GET_CARDS_SUCCESS: null,
    GET_CARDS_FAILURE: null,

    CREATE_BANK_ACCOUNT_REQUEST: null,
    CREATE_BANK_ACCOUNT_SUCCESS: null,
    CREATE_BANK_ACCOUNT_FAILURE: null,

    CREATE_CARD_REQUEST: null,
    CREATE_CARD_SUCCESS: null,
    CREATE_CARD_FAILURE: null,

    UPDATE_CARD_REQUEST: null,
    UPDATE_CARD_SUCCESS: null,
    UPDATE_CARD_FAILURE: null,

    DELETE_CARD_REQUEST: null,
    DELETE_CARD_SUCCESS: null,
    DELETE_CARD_FAILURE: null,

    DELETE_BANK_REQUEST: null,
    DELETE_BANK_SUCCESS: null,
    DELETE_BANK_FAILURE: null,

    UPDATE_BANK_REQUEST: null,
    UPDATE_BANK_SUCCESS: null,
    UPDATE_BANK_FAILURE: null,

    PAYOUT_EXTRA_USER_REQUEST: null,
    PAYOUT_EXTRA_USER_SUCCESS: null,
    PAYOUT_EXTRA_USER_FAILURE: null,

    RUN_REPORT_REQUEST: null,
    RUN_REPORT_SUCCESS: null,
    RUN_REPORT_FAILURE: null,

    DOWNLOAD_REPORT_REQUEST: null,
    DOWNLOAD_REPORT_SUCCESS: null,
    DOWNLOAD_REPORT_FAILURE: null,

    RESUME_SUBSCRIPTION_REQUEST: null,
    RESUME_SUBSCRIPTION_SUCCESS: null,
    RESUME_SUBSCRPITION_FAILURE: null,

    CREATE_SUPER_SUBSCRIPTION_REQUEST: null,
    CREATE_SUPER_SUBSCRIPTION_SUCCESS: null,
    CREATE_SUPER_SUBSCRPITION_FAILURE: null,

    CANCEL_SUPER_SUBSCRIPTION_REQUEST: null,
    CANCEL_SUPER_SUBSCRIPTION_SUCCESS: null,
    CANCEL_SUPER_SUBSCRPITION_FAILURE: null,

    LIST_SUBSCRIPTION_REQUEST: null,
    LIST_SUBSCRIPTION_SUCCESS: null,
    LIST_SUBSCRPITION_FAILURE: null,

    UPDATE_KEY_HIRER_REQUEST: null,
    UPDATE_KEY_HIRER_SUCCESS: null,
    UPDATE_KEY_HIRER_FAILURE: null,

    UPDATE_KEY_JOBBER_REQUEST: null,
    UPDATE_KEY_JOBBER_SUCCESS: null,
    UPDATE_KEY_JOBBER_FAILURE: null,

    UPDATE_NAVBAR_PARAMS: null,

    CREATE_WORKTIME_REQUEST: null,
    CREATE_WORKTIME_SUCCESS: null,
    CREATE_WORKTIME_FAILURE: null,

    GET_WORKTIMES_REQUEST: null,
    GET_WORKTIMES_SUCCESS: null,
    GET_WORKTIMES_FAILURE: null,

    TEMP_ACTION_REQUEST: null,
});
